import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import ClubbieModal from "../../../Modal/ClubbieModal";

const BracketDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  bracketName = "this bracket",
}) => {
  const renderFooter = () => (
    <div className="flex justify-end gap-3 w-full">
      <button
        type="button"
        className="px-6 py-3 text-sm font-medium text-app-text bg-app-card rounded-full hover:text-[#FEFCEB] transition-colors cursor-pointer"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        type="button"
        className="px-6 py-3 rounded-full bg-app-error hover:bg-red-600 text-blue-shade-8 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        onClick={onConfirm}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <LoadingSpinner size="small" />
            <span>Deleting...</span>
          </>
        ) : (
          "Delete"
        )}
      </button>
    </div>
  );

  return (
    <ClubbieModal
      isOpen={isOpen}
      width="500px"
      toggle={onClose}
      title={`Delete ${bracketName}`}
      footer={renderFooter()}
    >
      <p className="text-app-text-secondary text-[13px]">
        Are you sure you want to delete this bracket? This action cannot be undone.
      </p>
    </ClubbieModal>
  );
};

export default BracketDeleteModal;
